<template>
    <div>
        <search-box
          ref="searchForm" :columns="searchBoxColumns" @search="search" @btnReset="handleReset"
        :defaultValue="defaultValue">
        </search-box>
        <el-tabs class="tabs" v-model="activeName">
            <el-tab-pane
                v-for="item in tabs"
                :label="item.text"
                :name="item.index"
                :key="item.index"></el-tab-pane>
        </el-tabs>
        <component :is="currentComponent"
          :paginationData="paginationData"
          @paginationChange="paginationChange"
          :tableData="tableData"
          />
    </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import config from '../config'
import OrderDetail from '../components/orderDetail.vue'
import WriteoffDetail from '../components/writeoffDetail.vue'
import moment from 'moment'
import { reconciliationListApi } from '../services'

export default {
  name: 'payAccountConf',
  components: {
    OrderDetail,
    WriteoffDetail,
  },
  data() {
    const { searchBoxColumns } = config.call(this)
    return {
      defaultValue: {
        chargeEndTime: [],
      },
      formData: {},
      params: {},
      tableData: [],
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [5, 10, 20, 50],
      },
      searchBoxColumns,
      activeName: '0',
      tabs: [
        {
          index: '0',
          text: '订单明细',
        },
        {
          index: '1',
          text: '核销订单明细',
        },
      ],
      componentMap: {
        0: 'OrderDetail',
        1: 'WriteoffDetail',

      },
    }
  },
  watch: {
    'formData.date': {
      handler(o) {
        if (Array.isArray(o) && o.length === 2) {
          this.formData.tradeTimeStart = moment(o[0]).format('YYYY-MM-DD')
          this.formData.tradeTimeEnd = moment(o[1]).format('YYYY-MM-DD')
        }
      },
      deep: true,
    },
    activeName(v) {
      if (v === '1') {
        this.searchBoxColumns.splice(1, 1)
      } else {
        this.searchBoxColumns.splice(1, 0, {
          type: 'select',
          label: '订单类型',
          key: 'orderType',
          source: [{ label: '支付订单', value: 1 }, { label: '退款订单', value: 2 }],
          options: {
            clearable: true,
          },
        })
      }
      this.handleReset()
    },
  },
  computed: {
    currentComponent() {
      return this.componentMap[this.activeName]
    },
  },
  methods: {
    search(formData) {
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1
      if (Array.isArray(formData.chargeEndTime) && formData.chargeEndTime.length === 2) {
        this.formData.tradeTimeStart = moment(formData.chargeEndTime[0]).format('YYYY-MM-DD')
        this.formData.tradeTimeEnd = moment(formData.chargeEndTime[1]).format('YYYY-MM-DD')
        delete formData.chargeEndTime
      }
      const { billId } = this.$route.query
      this.params = {
        ...formData,
        billId,
        tradeTimeStart: this.formData.tradeTimeStart,
        tradeTimeEnd: this.formData.tradeTimeEnd }
      this.reconciliationList()
    },
    handleReset() {
      this.$refs.searchForm.initParams()
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1
      const { billId } = this.$route.query
      this.params = {
        billId,
      }
      this.tableData = []
      this.formData = { }
      this.setDefaultValue()
      this.reconciliationList()
    },
    paginationChange(payload) {
      const {
        pagination: { pageSize, pageNum },
      } = payload
      this.paginationData.pageSize = pageSize
      this.paginationData.pageNum = pageNum
      this.reconciliationList()
    },
    setDefaultValue() {
      const { billCycle } = this.$route.query
      const startDate = moment(billCycle, 'YYYYMM').startOf('month').valueOf()
      const endDate = moment(billCycle, 'YYYYMM').endOf('month').valueOf()

      this.defaultValue = {
        chargeEndTime: [startDate, endDate],
      }
      this.params.tradeTimeStart = moment(startDate).format('YYYY-MM-DD')
      this.params.tradeTimeEnd = moment(endDate).format('YYYY-MM-DD')
    },
    async reconciliationList() {
      const [err, _data] = await this.$to(reconciliationListApi.get(this.activeName)({
        ...this.params,
        pageNum: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize,
      }))
      if (err) return
      const { code } = _data
      let { data } = _data
      if (code === 1) {
        if (!data) {
          data = {}
        }
        if (!data.items) {
          data.items = []
        }
        this.paginationData.total = data.totalNum
        this.tableData = data.items
      }
    },
  },
  created() {
    const { billId } = this.$route.query
    this.params.billId = billId
    this.setDefaultValue()
    this.reconciliationList()
  },

}
</script>

<style lang="scss" scoped></style>
